import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import IconButton from "./IconButton";

type _TextWithIconOnPressed = () => void;

export interface TextWithIconProps extends BaseUIProps {
  key?: string;
  title: string;
  icon: ui.IconData;
  tooltip?: string;
  disableMode?: boolean;
  color?: ui.Color;
  hoverColor?: ui.Color;
  disabledColor?: ui.Color;
  size?: number;
  onPressed?: _TextWithIconOnPressed;
}

class _TextWithIconState extends ObservableComponent<TextWithIconProps> {
  static defaultProps = {
    title: "",
    icon: null,
    tooltip: "",
    disableMode: false,
    color: null,
    hoverColor: null,
    disabledColor: null,
    size: 0.0,
    onPressed: null,
  };
  public constructor(props: TextWithIconProps) {
    super(props);

    this.initState();
  }
  public get title(): string {
    return this.props.title;
  }
  public get icon(): ui.IconData {
    return this.props.icon;
  }
  public get tooltip(): string {
    return this.props.tooltip;
  }
  public get disableMode(): boolean {
    return this.props.disableMode;
  }
  public get color(): ui.Color {
    return this.props.color;
  }
  public get hoverColor(): ui.Color {
    return this.props.hoverColor;
  }
  public get disabledColor(): ui.Color {
    return this.props.disabledColor;
  }
  public get size(): number {
    return this.props.size;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(
      [
        "color",
        "disableMode",
        "disabledColor",
        "hoverColor",
        "icon",
        "size",
        "title",
        "tooltip",
      ],
      this.rebuild
    );
  }
  public componentDidUpdate(prevProps: TextWithIconProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.title !== this.props.title) {
      this.fire("title", this);
    }

    if (prevProps.icon !== this.props.icon) {
      this.fire("icon", this);
    }

    if (prevProps.tooltip !== this.props.tooltip) {
      this.fire("tooltip", this);
    }

    if (prevProps.disableMode !== this.props.disableMode) {
      this.fire("disableMode", this);
    }

    if (prevProps.color !== this.props.color) {
      this.fire("color", this);
    }

    if (prevProps.hoverColor !== this.props.hoverColor) {
      this.fire("hoverColor", this);
    }

    if (prevProps.disabledColor !== this.props.disabledColor) {
      this.fire("disabledColor", this);
    }

    if (prevProps.size !== this.props.size) {
      this.fire("size", this);
    }
  }
  public render(): ReactNode {
    return ui.Row({
      children: [
        TextView({
          data: this.title,
          style: new ui.TextStyle({
            fontSize: 16,
            fontFamily: "Open Sans",
            color: new ui.Color(0xff000000),
            fontWeight: ui.FontWeight.w600,
          }),
          className: "x7e8 vc",
          key: "0",
        }),
        IconButton({
          icon: this.icon,
          tooltip: this.tooltip,
          disableMode: this.disableMode,
          color: this.color,
          size: this.size,
          disabledColor: this.disabledColor,
          hoverColor: this.hoverColor,
          onPressed: () => {
            this.onIconButtonHandler();
          },
          className: "vc",
          key: "1",
        }),
      ],
      className: ui.join(this.props.className, "TextWithIcon vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onIconButtonHandler = (): void => {
    this.onPressed();
  };
  public get onPressed(): _TextWithIconOnPressed {
    return this.props.onPressed;
  }
}
export default function TextWithIcon(props: TextWithIconProps) {
  return React.createElement(_TextWithIconState, {
    ..._TextWithIconState.defaultProps,
    ...props,
  });
}
